import React from 'react';
import { Text, Center, Card, Stack, Button, Space } from '@mantine/core';

export interface ProfileCardProps {
  icon: React.FC<any>;
  hidden: boolean;
  text: string;
  label: string;
  button?: {
    label: string;
    onClick: () => void;
  };
}

const ProfileCard = ({ text, hidden, icon: Icon, label, button }: ProfileCardProps) => {
  return (
    <Stack align="stretch" justify="space-between">
      <Card>
        <Center>
          <Icon size={50} />
        </Center>
        <Text fw={700} fz="lg" mt={5} align="center">
          {label}
        </Text>
        <Space h="md" />
        <Text c="dimmed" fz="sm">
          {text}
        </Text>
      </Card>
      <Center>
        {button && (
          <Button size="sm" mt="sm" onClick={button.onClick}>
            {button.label}
          </Button>
        )}
      </Center>
    </Stack>
  );
};

export default ProfileCard;
